
const libPictView = require('pict-view');

class ConfigurationIndex extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	onAfterRender()
	{
		const session = this.pict.AppData.CurrentUser;
		const isHeadlightCustomer = session && session.IDCustomer === 1;

		if (!isHeadlightCustomer)
		{
			this.pict.ContentAssignment.addClass('.config-card-customer-only', 'is-hidden');
		}
		else
		{
			this.pict.ContentAssignment.removeClass('.config-card-customer-only', 'is-hidden');
		}

		return super.onAfterRender();
	}
}

module.exports = ConfigurationIndex;

module.exports.default_configuration =
{
	ViewIdentifier: 'ConfigurationIndex',
	DefaultRenderable: 'ConfigurationIndexWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	Templates:
	[
		{
			Hash: 'ConfigurationIndexWrap',
			Template: /*html*/`
			<section class="section">
				<div class="container">
					<div class="mb-5">
						<h1 class="title is-3">
							<span class="icon-text">
								<span class="icon"><i class="fas fa-sliders"></i></span>
								<span>Configurations</span>
							</span>
						</h1>
						<p class="subtitle is-5 has-text-grey">
							Manage all platform entities and settings
						</p>
					</div>

					<div class="config-panel-grid">
						<!-- Core Entities -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-database"></i></span>
										<span>Core Entities</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block config-card-customer-only" href="#/PSRS/Customer/List">
									<span class="panel-icon"><i class="fas fa-city"></i></span>
									<span>
										<span class="has-text-weight-semibold">Customers</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage customer tenants, codes, timezone settings, and enabled status.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/User/List">
									<span class="panel-icon"><i class="fas fa-users"></i></span>
									<span>
										<span class="has-text-weight-semibold">Users</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage user accounts, login credentials, email addresses, and names.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/Project/List">
									<span class="panel-icon"><i class="fas fa-folder-open"></i></span>
									<span>
										<span class="has-text-weight-semibold">Projects</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage projects, their status, external IDs, and associated configuration.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/Organization/List">
									<span class="panel-icon"><i class="fas fa-building"></i></span>
									<span>
										<span class="has-text-weight-semibold">Organizations</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage contractors and organizations with addresses, vendor codes, and approval status.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Roles & Permissions -->
							<nav class="panel">
								<p class="panel-heading has-background-info-soft">
									<span class="icon-text">
										<span class="icon has-text-info"><i class="fas fa-shield-halved"></i></span>
										<span>Roles &amp; Permissions</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/Role/List">
									<span class="panel-icon"><i class="fas fa-user-shield"></i></span>
									<span>
										<span class="has-text-weight-semibold">Roles</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define named roles with permission levels, types, and descriptions.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/UserRoleJoin/List">
									<span class="panel-icon"><i class="fas fa-user-tag"></i></span>
									<span>
										<span class="has-text-weight-semibold">User Role Assignments</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Assign roles to users and configure proxy role delegation.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/RoleEdge/List">
									<span class="panel-icon"><i class="fas fa-sitemap"></i></span>
									<span>
										<span class="has-text-weight-semibold">Role Hierarchy</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define parent-child relationships between roles to build permission inheritance.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/RolePermission/List">
									<span class="panel-icon"><i class="fas fa-key"></i></span>
									<span>
										<span class="has-text-weight-semibold">Role Permissions</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Configure granular permission hashes, allowed/denied flags, and context scoping per role.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Observation & Document Types -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-shapes"></i></span>
										<span>Observation &amp; Document Types</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationManifest/List">
									<span class="panel-icon"><i class="fas fa-clipboard-check"></i></span>
									<span>
										<span class="has-text-weight-semibold">Observation Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define observation manifests with display names, categories, and settings.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ArtifactType/List">
									<span class="panel-icon"><i class="fas fa-puzzle-piece"></i></span>
									<span>
										<span class="has-text-weight-semibold">Artifact Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define artifact schemata used by observation types for data collection.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ReportNamedInstance/List">
									<span class="panel-icon"><i class="fas fa-file-lines"></i></span>
									<span>
										<span class="has-text-weight-semibold">Document Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage report templates, default report settings, and hash identifiers.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Tags & Labels -->
							<nav class="panel">
								<p class="panel-heading has-background-info-soft">
									<span class="icon-text">
										<span class="icon has-text-info"><i class="fas fa-tags"></i></span>
										<span>Tags &amp; Labels</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationTag/List">
									<span class="panel-icon"><i class="fas fa-tags"></i></span>
									<span>
										<span class="has-text-weight-semibold">Observation Tags</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage tag values classified by type, used for labeling observations.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ProjectTagType/List">
									<span class="panel-icon"><i class="fas fa-layer-group"></i></span>
									<span>
										<span class="has-text-weight-semibold">Project Tag Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Configure which tag type categories are available per project.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Document Approvals -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-diagram-project"></i></span>
										<span>Document Approvals</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/DocumentApprovalWorkflow/List">
									<span class="panel-icon"><i class="fas fa-diagram-project"></i></span>
									<span>
										<span class="has-text-weight-semibold">Doc Workflows</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">State transition edges defining how documents move between approval statuses.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/DocumentApprovalState/List">
									<span class="panel-icon"><i class="fas fa-circle-nodes"></i></span>
									<span>
										<span class="has-text-weight-semibold">Doc Approval States</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Named approval states (Draft, Submitted, Approved, etc.) for documents.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/DocumentApprovalStep/List">
									<span class="panel-icon"><i class="fas fa-list-ol"></i></span>
									<span>
										<span class="has-text-weight-semibold">Doc Approval Steps</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Sequential approval steps with role requirements, locking, and hierarchy options.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Observation Approvals -->
							<nav class="panel">
								<p class="panel-heading has-background-info-soft">
									<span class="icon-text">
										<span class="icon has-text-info"><i class="fas fa-diagram-project"></i></span>
										<span>Observation Approvals</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationApprovalWorkflow/List">
									<span class="panel-icon"><i class="fas fa-diagram-project"></i></span>
									<span>
										<span class="has-text-weight-semibold">Obs Workflows</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">State transition edges defining how observations move between approval statuses.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationApprovalState/List">
									<span class="panel-icon"><i class="fas fa-circle-nodes"></i></span>
									<span>
										<span class="has-text-weight-semibold">Obs Approval States</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Named approval states (Draft, Submitted, Approved, etc.) for observations.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationApprovalStep/List">
									<span class="panel-icon"><i class="fas fa-list-ol"></i></span>
									<span>
										<span class="has-text-weight-semibold">Obs Approval Steps</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Sequential approval steps scoped by observation type with role requirements.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Contracts & Projects -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-file-contract"></i></span>
										<span>Contracts &amp; Projects</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ContractType/List">
									<span class="panel-icon"><i class="fas fa-file-contract"></i></span>
									<span>
										<span class="has-text-weight-semibold">Contract Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define contract lifecycle types — available statuses, default dates, allowed project types. CSV import available from the dashboard.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ProjectType/List">
									<span class="panel-icon"><i class="fas fa-diagram-project"></i></span>
									<span>
										<span class="has-text-weight-semibold">Project Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define project lifecycle types — available statuses, default dates, and which statuses require a Change Order for line-item edits.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Platform Capabilities -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-puzzle-piece"></i></span>
										<span>Platform Capabilities</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/ContractAdmin">
									<span class="panel-icon"><i class="fas fa-file-contract"></i></span>
									<span>
										<span class="has-text-weight-semibold">Contract Administration</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Enable and configure Contract Administration including payments, change orders, funding, and dashboards.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>
					</div>
				</div>
			</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ConfigurationIndexWrap',
			TemplateHash: 'ConfigurationIndexWrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
